"use client";
import { fadeUpAnimationData } from "@/data/animations.data";
import { AnimatePresence, motion } from "framer-motion";
import React, { ReactNode } from "react";

interface NavbarSubMenuWrapperProps {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
}

const NavbarSubMenuWrapper = ({
  children,
  className,
  isOpen,
}: NavbarSubMenuWrapperProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.section
          {...fadeUpAnimationData}
          className={` absolute hidden lg:block w-screen  h-fit bg-background rounded-xl  top-[calc(100%+8px)]  ${className}`}
        >
          {children}
        </motion.section>
      )}
    </AnimatePresence>
  );
};

export default NavbarSubMenuWrapper;
